<template>
  <div class="mgt-20px">
    <div class="card">
      <header class="header-card">
        <p>{{ $t('editionDemandeImpression.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="columns is-multiline">
              <div class="column is-4">
                <b-field :label="$t('editionDemandeImpression.infoGenerale.dateDemande')"
                  class="obligatoire">
                  <b-datepicker show-week-number
                    v-model="demandeImpression.dateDemande"
                    icon="calendar-today"
                    nearby-selectable-month-days editable>
                  </b-datepicker>
                </b-field>
              </div>
              <b-field class="column is-4 obligatoire"
                :label="$t('editionDemandeImpression.infoGenerale.etat')">
                <b-select v-model="demandeImpression.etat" expanded>
                  <option v-for="item in constantes.ETAT_DEMANDE_IMPRESSION"
                          :key="item.key"
                          :value="item.key">
                    {{ $t(item.libelle) }}
                  </option>
                </b-select>
              </b-field>
              <b-field class="column is-1"
                :label="$t('editionDemandeImpression.infoGenerale.couleur')">
                <b-select v-model="demandeImpression.couleur" expanded>
                  <option :value="null"></option>
                  <option v-for="item in constantes.COULEUR_IMPRESSION"
                          :key="item.key"
                          :value="item.key">
                    {{ $t(item.libelle) }}
                  </option>
                </b-select>
              </b-field>
              <b-field :label="$t('editionDemandeImpression.infoGenerale.typeOt')"
                class="column is-3">
                <b-select v-model="demandeImpression.typeOtId"
                  :disabled="aOt"
                  expanded>
                  <option :key="null" :value="null"></option>
                  <option v-for="type in typesOTImpression"
                        :key="type.id"
                        :value="type.id">
                    {{ type.libelle }}
                  </option>
                </b-select>
              </b-field>
              <b-field class="column is-4 obligatoire"
                :label="$t('editionDemandeImpression.infoGenerale.client')">
                <b-autocomplete
                  v-model="client"
                  :placeholder="$t('editionDemandeImpression.infoGenerale.client')"
                  :data="clients"
                  field="nomCommercial"
                  icon="magnify"
                  :loading="isFetchingClient"
                  :open-on-focus="true"
                  @input="getClientsDebounce"
                  @select="selectClient">
                  <template #empty>
                    {{$t(`general.autocomplete.${!isFetchingClient ? 'noRslt' : 'search'}`)}}
                  </template>
                </b-autocomplete>
              </b-field>
              <contact-autocomplete
                :label="$t('editionDemandeImpression.infoGenerale.demandeur')"
                :placeholder="$t('editionDemandeImpression.infoGenerale.demandeur')"
                :value="demandeImpression.contactDemandeur"
                :tiers="demandeImpression.client"
                :ajoutContact="false"
                @input="setContactDemandeur"
                class="column is-4"
                withContactPortail
                deletable/>
              <contact-autocomplete
                :label="$t('editionDemandeImpression.infoGenerale.receveur')"
                :placeholder="$t('editionDemandeImpression.infoGenerale.receveur')"
                :value="demandeImpression.contactReceveur"
                :tiers="demandeImpression.client"
                :ajoutContact="false"
                @input="setContactReceveur"
                class="column is-4"
                withContactPortail
                deletable/>
              <b-field class="column is-4"
                :label="$t('editionDemandeImpression.infoGenerale.quantite')">
                <qd-numberinput
                  v-model="demandeImpression.quantite"
                  :min="0"
                  :controls="false">
                </qd-numberinput>
              </b-field>
              <div class="column is-4">
                <b-field :label="$t('editionDemandeImpression.infoGenerale.dateLimite')">
                  <b-datepicker show-week-number
                    v-model="demandeImpression.dateLimite"
                    icon="calendar-today"
                    nearby-selectable-month-days editable>
                  </b-datepicker>
                </b-field>
              </div>
              <b-field class="column is-4"
                :label="$t('editionDemandeImpression.infoGenerale.nomVariante')">
                <b-input
                  v-model="demandeImpression.nomVariante">
                </b-input>
              </b-field>
              <b-field :label="$t('editionDemandeImpression.infoGenerale.tags')"
                class="column is-4">
                <query-tags-tag-input
                  :position="'is-right'"
                  :tooltipLabel="$t('editionCampagne.tagInfo')"
                  v-model="demandeImpression.tags"
                  field="tag"
                  :moduleTag="constantes.moduleDemandeImpression">
                </query-tags-tag-input>
              </b-field>
              <b-field class="column is-4"
                :label="$t('editionDemandeImpression.infoGenerale.nomFichierRip')">
                <b-input
                  v-model="demandeImpression.nomFichierRip">
                </b-input>
              </b-field>
              <div class="column is-4">
                <div class="columns is-marginless is-align-items-end">
                  <user-autocomplete
                    v-model="demandeImpression.graphisteEnChargeId"
                    :label="$t('editionDemandeImpression.infoGenerale.graphisteEnCharge')"
                    :obligatoire="false"
                    class="column is-paddingless mgb-0"
                    ref="graphisteEnCharge"
                  />
                  <div class="column is-narrow is-paddingless">
                    <qd-button
                      @click="$refs.graphisteEnCharge.setUser(utilisateur)"
                      class="button is-primary mgl-10px">
                      {{ $t('editionDemandeImpression.actions.updateGraphiste')}}
                    </qd-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { getAll as getAllTiers } from '@/api/tiers';
import {
  COULEUR_IMPRESSION,
  ETAT_DEMANDE_IMPRESSION,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { DEMANDE_IMPRESSION as moduleDemandeImpression } from '@/configuration/parametrage/tagConf';
import userAutocomplete from '@/components/commun/user/userAutocomplete';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';
import ContactAutocomplete from '@/components/general/contactAutocomplete';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');

export default {
  name: 'informations_generales',
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
  },
  components: {
    queryTagsTagInput,
    userAutocomplete,
    ContactAutocomplete,
  },
  data() {
    return {
      permDemandeImpression: DEMANDE_IMPRESSION,
      constantes: {
        ETAT_DEMANDE_IMPRESSION,
        COULEUR_IMPRESSION,
        moduleDemandeImpression,
      },
      clients: [],
      contacts: [],
      search: null,
      isFetchingClient: false,
      client: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    typesOTImpression() {
      return this.parametre(PARAMETRES_KEYS.typeOt)
        .filter(type => type.actionInterventionOt === IMPRESSION_AFFICHE);
    },
    aOt() {
      return this.demandeImpression.devisCommandes?.length > 0;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getClientsDebounce: debounce(async function getClients(search) {
      try {
        this.isFetchingClient = true;
        this.clients = (await getAllTiers({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            estLieuStockage: true,
          },
        })).data.result.items;
        this.isFetchingClient = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingClient = false;
      }
    }, 300),
    selectClient(option) {
      this.demandeImpression.clientId = option ? option.id : null;
      this.demandeImpression.client = option;
      this.demandeImpression.dispositifId = null;
      this.demandeImpression.contactDemandeur = null;
      this.demandeImpression.contactDemandeurId = null;
      this.demandeImpression.contactReceveur = null;
      this.demandeImpression.contactReceveurId = null;
    },
    deleteClient() {
      this.client = null;
      this.demandeImpression.clientId = null;
    },
    setContactDemandeur(contact) {
      this.demandeImpression.contactDemandeurId = contact?.id || null;
      this.demandeImpression.contactDemandeur = contact || null;
    },
    setContactReceveur(contact) {
      this.demandeImpression.contactReceveurId = contact?.id || null;
      this.demandeImpression.contactReceveur = contact || null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.client = this.demandeImpression.client?.nomCommercial;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
